/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
/* Predefined key value strings in WEB API */
export const ENTER = "Enter";
export const CAPITAL_F = "F";
export const SMALL_F = "f";
export const ESCAPE = "Escape";
export const F3 = "F3";
export const SMALL_G = "g";
export const CAPITAL_G = "G";
export const F6 = "F6";
export const ARROW_UP = "ArrowUp";
export const ARROW_DOWN = "ArrowDown";
